import {Dispatch} from "redux";
import {setMeAction} from "../../../app/setMe/actions";
import {setModalVisibilityAction} from "../../../app/setModalVisibility/actions";
import {ModalType} from "../../../models/custom/enums/modalType";
import {MeDto} from "../../../models/dtos/me.dto";
import axios from "../../../utilities/axios";

export const getMeRequest = async (dispatch: Dispatch): Promise<MeDto> => {
  try {
    const response = await axios.get<MeDto>(
      `${process.env.REACT_APP_BASE_URL}/users/me`,
    );
    const me = response.data;
    if (me.shouldSeeScoreboard) {
      dispatch(setModalVisibilityAction({modal: ModalType.SCOREBOARD, isVisible: true}));
    }
    if (me.shouldSeeWinner) {
      dispatch(setModalVisibilityAction({modal: ModalType.MONTHLY, isVisible: true}));
    }
    dispatch(setMeAction(me));
    return me;
  } catch (error) {
    throw error;
  }
}
